import Cookies from 'js-cookie';

const updateFidelityData = () => {
  const cookieName = 'fidelityDataUpdated';
  const alreadyUpdated = Cookies.get(cookieName);

  if (!alreadyUpdated) {
    forceUpdateFidelityData();
    Cookies.set(cookieName, 'true', { expires: 1 / 24 });
  }
};

const forceUpdateFidelityData = () => {
  const gid = window.dAgency.fidelityCustomerData.gid;
  const igucliente = window.dAgency.fidelityCustomerData.igucliente;
  const fidelitySubscription =
    window.dAgency.fidelityCustomerData.fidelitySubscription;

  if (fidelitySubscription) {
    if (igucliente && gid) {
      const data = {
        igucliente: igucliente,
        id: gid,
      };

      fetch(
        'https://lidia-prod-push-fidelity-701241463904.europe-west1.run.app',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': 'tE3QAZEbN8iKHI8I3FjY',
          },
          body: JSON.stringify(data),
        },
      )
        .then((res) => (res.ok ? res.text() : Promise.reject(res)))
        .then((response) => {
          console.log('Fidelity update success', response);
        })
        .catch(async (err) => {
          const errText = await err.text?.();
          console.error('Fidelity update error:', err.status, err.statusText);
          console.error('Fidelity update error:', errText || err);
        });
    } else {
      console.warn('Fidelity update skipped: missing data');
      return;
    }
  }
};

export { updateFidelityData, forceUpdateFidelityData };
